import React, { useState } from 'react';
import cls from 'classnames';
import { Collapse } from 'react-collapse';
import Bundle from '../../../models/Bundle';
import { Button } from '../../core/button';
import FontAwesomeIcon from '../../core/fa_icon';
import { Field } from '../../core/field';
import { StockList } from '../stock_list';
import styles from './bundle_form.module.scss';
import Product from '../../../models/Product';

type Props = {
  disabled?: boolean;
  maxBundleCount?: number;
  bundleCount?: number;
  onSubmit: (bundle: Bundle) => void;
  energyItems: Product[];
  bundle: Bundle;
  onChange: (bundle: Bundle) => void;
}

/**
 * For inputting order information.
 */
export const BundleForm: React.FC<Props> = ({
  disabled,
  bundle,
  bundleCount,
  maxBundleCount,
  onChange,
  onSubmit,
  energyItems,
}) => {
  const [headerExpanded, setHeaderExpanded] = useState(false);

  const bundleValid = bundle?.valid;

  const limitReached = typeof bundleCount === 'number' && typeof maxBundleCount === 'number' && bundleCount >= maxBundleCount;

  if (limitReached) {
    disabled = true;
  }

  return (
    <form
      className={cls([styles.form, disabled ? styles.disabled : null])}
      onSubmit={e => {
        onSubmit(bundle);
        e.preventDefault();
        return false;
      }}>
      <header>
        <div className={styles.row}>
          <div className={styles.row} style={{ flexGrow: 1 }}>
            <h3>Lägg till produkt</h3>

            <Button
              onClick={e => {
                e.preventDefault();
                setHeaderExpanded(flag => !flag);
                return false;
              }}
              weight="simple">
              <FontAwesomeIcon name={"question-circle"} />
            </Button>
          </div>
        </div>
        <Collapse isOpened={headerExpanded}>
          <p className={styles.help}>
            Välj en eller flera produkter
          </p>
        </Collapse>
      </header>

      <div className={styles.lists}>
        <StockList
          checkedItems={bundle.energyItems}
          maxLength={1}
          items={energyItems}
          onCheckedItemsChange={items => {
            onChange(new Bundle({
              ...bundle,
              energyItems: items
            }))
          }} />
      </div>

      <div className="flex-row" style={{ alignItems: 'flex-end', gap: 12 }}>
        <Field
          label="Anläggningsadress"
          value={bundle.address}
          containerClassName={styles.field}
          disabled={disabled}
          onTextValueChange={address => onChange(new Bundle({ ...bundle, address }))}
        />

        <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
          <Field
            label="Postnr"
            containerStyle={{ width: 80, flexGrow: 0 }}
            maxLength={6}
            value={bundle.postalCode}
            containerClassName={styles.field}
            disabled={disabled}
            onTextValueChange={postalCode => onChange(new Bundle({ ...bundle, postalCode }))}
          />
          <Field
            label="Ort"
            containerStyle={{ width: 140, flexGrow: 0 }}
            value={bundle.city}
            containerClassName={styles.field}
            disabled={disabled}
            onTextValueChange={city => onChange(new Bundle({ ...bundle, city }))}
          />
        </div>
        <Button
          type="submit"
          weight={bundleValid ? "primary" : "normal"}
          className={styles.add}
          disabled={!bundleValid || disabled}>
          Lägg till produkt
        </Button>
      </div>

      <div className={styles.disabledContainer}>
        <FontAwesomeIcon name={limitReached ? "exclamation-circle" : "check"} className={styles.disabledIco} />
        {
          limitReached ? (
            <p>Avtalsmall stödjer högst {maxBundleCount} produkter</p>
          ) : null
        }
      </div>
    </form>
  );
}